export default "__VITE_ASSET__YRqhro8E__"